// App
export const APP_TOGGLE_SHOW_SETTINGS_STATE = 'APP_TOGGLE_SHOW_SETTINGS_STATE'
export const APP_SET_SHOW_SETTINGS_STATE = 'APP_SET_SHOW_SETTINGS_STATE'
export const APP_SET_SHOW_LOGIN_STATE = 'APP_SET_SHOW_LOGIN_STATE'
export const APP_SET_AUTOLAUNCH_ENABLED_STATE = 'APP_SET_AUTOLAUNCH_ENABLED_STATE'
export const APP_SET_UI_VERSION = 'APP_SET_UI_VERSION'

// Launcher
export const LAUNCHER_UPDATE_READY_STATE = 'LAUNCHER_UPDATE_READY_STATE'

// Logger
export const LOGGER_LOG = 'LOGGER_LOG'

// Feature
export const LOCALE_CHANGED = 'FEATURES_LOCALE_CHANGED'
export const SERVER_PROFILES_CHANGED = 'FEATURES_SERVER_PROFILES_CHANGED'
export const PROCESS_CHANGED = 'FEATURES_PROCESS_CHANGED'

// HACK!!!!
export const CLIENT_LAUNCHER_SET_TOKEN = 'HACK_HACK_HACK_CLIENT_LAUNCHER_SET_TOKEN'
export const CLIENT_LAUNCHER_SET_EULA = 'HACK_HACK_HACK_CLIENT_LAUNCHER_SET_EULA'
export const CLIENT_LAUNCHER_RESET = 'HACK_HACK_HACK_CLIENT_LAUNCHER_RESET'



// WEBPACK FOOTER //
// ./src/constants/index.js